import React from "react";
import { FaHeart } from "react-icons/fa";

import { FaXmark } from "react-icons/fa6";

import {
  HEADER_COLOR,
  PRIMARY_COLOR,
  TERTIARY_COLOR,
  //   TEXT_COLOR,
} from "./../constants/theme";
import { sidebarItems } from "../constants/sidebar";
import { Link } from "react-router";
import Config from "../services/config";

const Sidebar = ({ toggleSelf }) => {
  return (
    <div
      className=""
      style={{
        position: "absolute",
        backgroundColor: "rgb(242, 242, 242)",
        borderTopRightRadius: "12px",
        borderBottomRightRadius: "12px",
        borderRight: "1px solid #ffffff",
        // top: '71px',
        left: "0",
        top: "0",
        // height: '100%',
        // minHeight: 'calc(100vh - 71px)',
        zIndex: "500",
      }}
    >
      <div
        className="row mx-auto flex-column align-items-center justify-content-between position-relative"
        style={{
          minHeight: "100vh",
          maxHeight: "100vh",
          minWidth: "max-content",
          paddingBottom: "25px",
        }}
      >
        <div
          className="w-auto p-0"
          style={{
            position: "absolute",
            top: "19px",
            right: "7px",
          }}
        >
          <FaXmark
            style={{
              height: "28px",
              width: "28px",
              color: TERTIARY_COLOR,
            }}
            onClick={() => toggleSelf(false)}
          ></FaXmark>
        </div>
        <div className="col-12 p-0">
          <div
            className="row w-100 mx-auto flex-column align-items-start justify-content-start flex-nowrap"
            style={{
              maxHeight: "calc(100vh - 68.68px)",
              overflowY: "auto",
              borderTopRightRadius: "12px",
            }}
          >
            <div
              className="col-12 p-0"
              style={{
                borderBottom: "1px solid #ffffff",
              }}
            >
              <div
                className="d-flex align-items-center justify-content-start "
                style={{
                  gap: "8px",
                  padding: "16.5px 20px",
                  backgroundColor: PRIMARY_COLOR,
                }}
              >
                <div
                  className="text"
                  style={{
                    fontSize: "22px",
                    color: TERTIARY_COLOR,
                    fontWeight: "600",
                  }}
                >
                  SmileApp
                </div>
              </div>
            </div>
            {sidebarItems?.map((item, index) => {
              let IconComponent = item?.icon;

              return (
                <Link
                  to={item?.link}
                  className="col-12 p-0 text-decoration-none"
                  key={index}
                  style={{
                    borderBottom: "1px solid #ffffff",
                  }}
                >
                  <div
                    className="d-flex align-items-center justify-content-start "
                    style={{
                      gap: "18px",
                      padding: "15px 20px 15px 20px",
                    }}
                  >
                    <IconComponent
                      style={{
                        height: "21px",
                        width: "21px",
                        fill: "#9900cc",
                      }}
                    />

                    <div
                      className="d-flex flex-column align-items-start justify-content-center"
                      style={{
                        lineHeight: "1",
                        minWidth: "165px",
                      }}
                    >
                      <div
                        className=""
                        style={{
                          fontSize: "12px",
                          color: PRIMARY_COLOR,
                          fontWeight: "600",
                        }}
                      >
                        {item.title}
                      </div>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>

        <div className="col-12 p-0">
          <div
            className="row w-100 mx-auto flex-column align-items-center justify-content-center text-center"
            style={{
              lineHeight: "1",
              gap: "7px",
              padding: "15px 0",
              borderBottom: "1px solid #ffffff",
              borderTop: "1px solid #ffffff",
            }}
          >
            <div className="col-auto p-0">
              <div
                className="d-flex align-items-end justify-content-center"
                style={{
                  fontSize: "11px",
                  color: HEADER_COLOR,
                  fontWeight: "600",
                  letterSpacing: "0.04ch",
                  // gap: '4px'
                }}
              >
                Digital Custodian{" "}
                {
                  <FaHeart
                    style={{
                      width: "11px",
                      height: "11px",
                      marginLeft: "7px",
                      marginRight: "5px",
                      marginBottom: "1.16px",
                      overflow: "visible",
                    }}
                  />
                }{" "}
                {Config.appEnv} - {Config.appVersion}
              </div>
            </div>

            {/* <div className='col-auto p-0'>
                                <div className='' style={{
                                    color: TEXT_COLOR,
                                    fontSize: '12px'
                                }}>
                                    v 1.0
                                </div>
                            </div> */}
          </div>
        </div>
      </div>
    </div>

    // <div
    //     // className={`animate__animated ${isSidebarOpen ? "animate__slideInLeft" : "animate__slideInRight"}`}
    //     className={``}
    //     style={{
    //         position: "absolute",
    //         zIndex: 14,
    //         top: "63px",
    //         width: "fit-content",
    //         backgroundColor: "rgb(242, 242, 242)",
    //         borderTopRightRadius: "12px",
    //         borderBottomRightRadius: "12px"
    //     }}>
    //     <div
    //         className='d-flex flex-column align-items-start'>
    //             <div className='' style={{
    //                 height: '70px',

    //             }}>

    //             </div>

    //         {
    //             dummyArr2?.map((item, index) => {
    //                 return (
    //                     <div key={index} className='col-12 top-border d-flex align-items-center px-4 py-3'>
    //                         <img width={70} height={70} src={item?.icon} />
    //                         <div className='ms-2 d-flex flex-column align-items-start'>
    //                             <h5
    //                                 style={{
    //                                     fontSize: "1.0rem",
    //                                     fontWeight: "bold"
    //                                 }}
    //                                 className="mb-0 primary-text"><u>{item?.title}</u></h5>
    //                             <small
    //                                 style={{
    //                                     fontSize: "0.75em",
    //                                     lineHeight: "1.2"
    //                                 }}
    //                                 className="mb-0 default-text">{item?.des}</small>
    //                         </div>
    //                     </div>
    //                 )
    //             })
    //         }
    //         <div className='col-12 d-flex flex-column text-center pt-5 pb-1 bottom-border mb-4'>
    //             <h2 className='primary-text mb-0 fw-bold'>SmileApp</h2>
    //             <p className='mb-0 default-text'>v1.0</p>
    //         </div>

    //     </div>
    // </div>
  );
};

export default Sidebar;
